export const defaultFontFamily = { fontFamily: 'Montserrat' };
